module.exports = __webpack_public_path__ + "static/media/label.55265e2a.svg";